// @ts-check
import { TRACKING } from 'common/constants/constants';
import TermsAndPolicy from './TermsAndPolicy';
import Icon from 'components/base/Icon';
import { LBButton } from '@linearb/buzz';
import { isSurveyFlow } from 'common/utils/utils';

const Separator = () => <span className='hidden sm:block text-sm mx-2'>|</span>;

const BottomBar = ({ showBetaLink, organizationName }) => {
  if (isSurveyFlow()) return <div />;

  return (
    <div className='footer-id flex flex-col sm:flex-row items-center justify-center z-[1] p-2 gap-2'>
      <Icon
        name='Logo'
        color='darkBlue'
        size='x-medium'
        className='sm:hidden'
      />
      <span className='text-sm mx-1'>
        &copy; LinearB Inc. {new Date().getFullYear()}. All rights reserved.
      </span>
      <Separator />
      <LBButton asChild size='sm'>
        <a
          href='https://linearb.io/blog/software-engineering-intelligence-101'
          target='__blank'
          rel='noopener noreferrer'
        >
          Software Engineering Intelligence +
        </a>
      </LBButton>
      <Separator />
      <TermsAndPolicy
        page_tab={TRACKING.PAGE_TABS.BOTTOM_BAR}
        separator={<Separator />}
      />
      {organizationName && (
        <>
          <Separator />
          <span className='text-sm mx-1'>{organizationName}</span>
        </>
      )}
      {showBetaLink && (
        <>
          <Separator />
          <LBButton asChild variant='link'>
            <a
              target='_blank'
              href={`https://${window.location.hostname.replace(
                'app',
                'app2'
              )}/dashboard`}
              rel='noopener noreferrer'
            >
              Beta site
            </a>
          </LBButton>
        </>
      )}
    </div>
  );
};

export default BottomBar;
